/**
 * @generated SignedSource<<5a8eb91f5dcb067187b1ba0c5ede214f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SeriesState = "READY" | "WAITING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SeriesRouteData$data = {
  readonly description: string | null | undefined;
  readonly state: SeriesState;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesBlockSeriesData">;
  readonly " $fragmentType": "SeriesRouteData";
};
export type SeriesRouteData$key = {
  readonly " $data"?: SeriesRouteData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesRouteData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesRouteData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesBlockSeriesData"
    }
  ],
  "type": "Series",
  "abstractKey": null
};

(node as any).hash = "fd5a1e72a4218f3c3ead140d1b9de022";

export default node;
